var exports = {
  "zr": "x620889e6--717e80--root",
  "UE": "x620889e6--717e80--arrow",
  "C7": "x620889e6--717e80--arrow-collapsed",
};

module.exports = exports;
